module.exports = __webpack_public_path__ + "static/media/network.c0f0c32e.jpg";